<div class="container-fluid">
  <app-pagetitle
    title="Production Planning"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>

  <div class="row mb-3">
    <div class="form-group col-md-3">
      <label>Select Department</label>
      <select
        class="form-control"
        [(ngModel)]="selecteddepartmentName"
        (change)="departmentChange($event.target.value)"
      >
        <option
          *ngFor="let line of departmentData"
          [value]="line.departmentName"
        >
          {{ line.departmentName }}
        </option>
      </select>
    </div>

    <div class="form-group col-md-3">
      <label>Select Machine</label>
      <select
        class="form-control"
        [(ngModel)]="selectedDeviceName"
        (change)="deviceChange($event.target.value)"
        [disabled]="!devicelistData.length"
      >
        <option *ngFor="let line of devicelistData" [value]="line.deviceName">
          {{ line.deviceName }}
        </option>
      </select>
    </div>
  </div>

  <!-- No Machine Available Message -->
  <div *ngIf="!devicelistData.length" class="row">
    <div class="col-12">
      <div class="alert alert-warning alert-dismissible fade show" role="alert">
        <strong>No Machine Available!</strong> There are no Wimera-K2 machines
        available for production planning in the selected department.
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Calendar Section -->
  <div class="row" *ngIf="devicelistData.length">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <full-calendar
            #calendar
            defaultView="dayGridMonth"
            [header]="{
              left: 'prev,next today',
              center: 'title',
              right: ''
            }"
            [plugins]="calendarPlugins"
            [eventResizableFromStart]="true"
            [eventLimit]="true"
            [editable]="false"
            themeSystem="bootstrap"
            [weekends]="calendarWeekends"
            [validRange]="{ start: minDate, end: maxDate }"
            [events]="calendarEvents"
            (dateClick)="openModal(content, $event)"
            (eventClick)="openEditModal(editcontent, $event)"
          >
          </full-calendar>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Add New Event</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="formData" (ngSubmit)="addEventData()">
      <div class="row">
        <div class="col-md-6 form-group">
          <label>Select Shift</label>
          <select
            class="form-control"
            formControlName="shiftName"
            (change)="shiftChange($event.target.value)"
          >
            <option value="" disabled>Select Shift</option>
            <option *ngFor="let shift of shiftsArr" [value]="shift.shiftName">
              {{ shift.shiftName }}
            </option>
          </select>
        </div>

        <div class="col-md-6 form-group" *ngIf="deviceType == 'no_part'">
          <label>Operator</label>
          <select
            class="form-control"
            (change)="NoonOperatorChange($event, 'add')"
            formControlName="operatorName"
            [ngClass]="{
              'is-invalid':
                formData.get('operatorName')?.touched &&
                formData.get('operatorName')?.errors
            }"
          >
            <option value="">Select Operator</option>
            <option *ngFor="let user of usersData" [value]="user.name">
              {{ user.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="mt-3" *ngIf="deviceType !== 'no_part'">
        <div formArrayName="target">
          <div
            *ngFor="let group of targetFormArray.controls; let i = index"
            [formGroupName]="i"
            class="border p-2 mb-2 rounded"
          >
            <div class="row">
              <div class="col-md-4 form-group">
                <label><small>Part</small></label>
                <select
                  class="form-control form-control-sm"
                  formControlName="partName"
                  (change)="onPartChange($event, i)"
                >
                  <option value="" disabled>Select Part</option>
                  <option *ngFor="let part of partData" [value]="part.partName">
                    {{ part.partName }}
                  </option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label><small>Operation</small></label>
                <select
                  class="form-control form-control-sm"
                  formControlName="operationName"
                  (change)="onOperationChange($event, i)"
                >
                  <option value="" disabled>Select Operation</option>
                  <option
                    *ngFor="let op of partOperationMap[i]"
                    [value]="op.item_text"
                  >
                    {{ op.item_text }}
                  </option>
                </select>
              </div>

              <div class="col-md-4 form-group">
                <label><small>Shift Capacity</small></label>
                <input
                  class="form-control form-control-sm"
                  placeholder="Capacity"
                  formControlName="shiftCapacity"
                  readonly
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label><small>Target</small></label>
                <input
                  type="number"
                  placeholder="Target"
                  (input)="onTargetChange(i)"
                  class="form-control form-control-sm"
                  formControlName="target"
                />
              </div>
              <div class="col-md-6 form-group">
                <label><small>Operator</small></label>
                <select
                  class="form-control form-control-sm"
                  (change)="onOperatorChange(null, $event, i, 'add')"
                  formControlName="operatorName"
                >
                  <option value="" selected disabled>Select Operator</option>
                  <option *ngFor="let op of usersData" [value]="op.name">
                    {{ op.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label><small>Start Time</small></label>
                <select
                  class="form-control form-control-sm"
                  [value]="getStartTimeHHMM(i)"
                  (change)="onStartTimeSelect($event, i)"
                  [attr.disabled]="
                    group.get('startTime')?.disabled ? true : null
                  "
                >
                  <option *ngFor="let t of getTimeOptions(i)" [value]="t">
                    {{ t }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 form-group">
                <label><small>End Time</small></label>

                <input
                  class="form-control form-control-sm"
                  placeholder="End Time"
                  formControlName="endTime"
                  readonly
                />
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-1 d-flex align-items-end justify-content-center form-group"
              >
                <button
                  *ngIf="i === targetFormArray.length - 1 && i != 0"
                  type="button"
                  class="btn btn-link text-danger p-0 mb-2"
                  (click)="removeTargetRow(i)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center mb-2">
          <label class="mb-0">Add Planning</label>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary ml-2"
            [disabled]="formData.invalid"
            (click)="addPartwiseTarget('add')"
          >
            <i class="fas fa-plus"></i> Add Row
          </button>
        </div>
      </div>
      <div class="form-group col-md-12">
        <div class="form-check d-flex align-items-center">
          <input
            class="form-check-input"
            formControlName="isSamePartNextShift"
            type="checkbox"
            id="isSamePart"
          />
          <label class="form-check-label mt-2 mb-0" for="isSamePart">
            Continue for future shifts until new Production
          </label>
        </div>
      </div>

      <div class="modal-footer px-0 pb-0">
        <button class="btn btn-secondary" type="button" (click)="close()">
          Close
        </button>
        <button
          class="btn btn-primary"
          type="submit"
          [disabled]="formData.invalid || isEnable"
        >
          Save
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #editcontent let-modal>
  <div class="modal-header">
    <h5>Edit Production Planning</h5>
    <button type="button" class="close" (click)="modal.dismiss(); close2()">
      &times;
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="formData">
      <!-- Shift + Operator -->
      <div class="row">
        <div class="col-md-6 form-group">
          <label>Shift</label>
          <input class="form-control" formControlName="shiftName" readonly />
        </div>

        <div class="col-md-6 form-group" *ngIf="deviceType == 'no_part'">
          <label>Operator</label>
          <select
            class="form-control"
            (change)="NoonOperatorChange($event, 'edit')"
            formControlName="operatorName"
          >
            <option *ngFor="let user of usersData" [value]="user.name">
              {{ user.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="mt-3" *ngIf="deviceType !== 'no_part'">
        <!-- 🔥 Partwise Planning -->
        <div formArrayName="target">
          <div
            *ngFor="let group of targetFormArray.controls; let i = index"
            [formGroupName]="i"
            class="border p-2 mb-2 rounded"
          >
            <div class="row">
              <div class="col-md-4 form-group">
                <label><small>Part</small></label>
                <select
                  class="form-control form-control-sm"
                  formControlName="partName"
                  (change)="onPartChange($event, i)"
                >
                  <option value="" disabled>Select Part</option>
                  <option *ngFor="let part of partData" [value]="part.partName">
                    {{ part.partName }}
                    <span *ngIf="part.isDeleted">(Deleted)</span>
                  </option>
                </select>
              </div>
              <div class="col-md-4 form-group">
                <label><small>Operation</small></label>
                <select
                  class="form-control form-control-sm"
                  formControlName="operationName"
                  (change)="onOperationChange($event, i)"
                >
                  <option value="" disabled>Select Operation</option>
                  <option
                    *ngFor="let op of partOperationMap[i]"
                    [value]="op.item_text"
                  >
                    {{ op.item_text }}
                    <span *ngIf="op.isDeleted">(Deleted)</span>
                  </option>
                </select>
              </div>

              <div class="col-md-4 form-group">
                <label><small>Shift Capacity</small></label>
                <input
                  class="form-control form-control-sm"
                  placeholder="Capacity"
                  formControlName="shiftCapacity"
                  readonly
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label><small>Target</small></label>
                <input
                  type="number"
                  placeholder="Target"
                  (input)="onTargetChange(i)"
                  class="form-control form-control-sm"
                  formControlName="target"
                />
              </div>
              <!-- <div class="col-md-6 form-group">
                <label><small>Operator</small></label>
                <select class="form-control form-control-sm" (focus)="captureOldOperator(i)"
                  (change)="onOperatorChange(changeContent,$event, i,'edit')" formControlName="operatorName">
                  <option value="" selected disabled>Select Operator</option>
                  <option *ngFor="let op of usersData" [value]="op.name">
                    {{ op.name }}
                  </option>
                </select>
              </div> -->
              <div class="col-md-6 form-group">
                <label><small>Operator</small></label>
                <div class="input-group input-group-sm">
                  <select
                    class="form-control form-control-sm"
                    (focus)="captureOldOperator(i)"
                    (change)="
                      onOperatorChange(changeContent, $event, i, 'edit')
                    "
                    formControlName="operatorName"
                  >
                    <option value="" selected disabled>Select Operator</option>
                    <option *ngFor="let op of usersData" [value]="op.name">
                      {{ op.name }}
                    </option>
                  </select>
                  <div
                    class="input-group-append"
                    *ngIf="
                      isCurrentShift && isCurrentPacketByIndex(i) && !isReset
                    "
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      title="Edit production/operator"
                      (click)="
                        captureOldOperator(i); onProductionChoice(true, null, i)
                      "
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 form-group">
                <label><small>Start Time</small></label>
                <select
                  class="form-control form-control-sm"
                  [value]="getStartTimeHHMM(i)"
                  (change)="onStartTimeSelect($event, i)"
                  [attr.disabled]="
                    group.get('startTime')?.disabled ? true : null
                  "
                >
                  <option *ngFor="let t of getTimeOptions(i)" [value]="t">
                    {{ t }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 form-group">
                <label><small>End Time</small></label>

                <input
                  class="form-control form-control-sm"
                  placeholder="End Time"
                  formControlName="endTime"
                  readonly
                />
              </div>
            </div>
            <div class="row">
              <div
                class="col-md-1 d-flex align-items-end justify-content-center form-group"
              >
                <button
                  *ngIf="
                    i === targetFormArray.length - 1 &&
                    i !== 0 &&
                    isFuturePacketByIndex(i)
                  "
                  type="button"
                  class="btn btn-link text-danger p-0 mb-2"
                  (click)="removeTargetEditRow(i)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center mb-2">
          <label class="mb-0">Add Planning</label>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary ml-2"
            [disabled]="formData.invalid"
            (click)="addPartwiseTarget('edit')"
          >
            <i class="fas fa-plus"></i> Add Row
          </button>
        </div>
      </div>
      <div class="form-group col-md-12">
        <div class="form-check d-flex align-items-center">
          <input
            class="form-check-input"
            formControlName="isSamePartNextShift"
            type="checkbox"
            id="isSamePart"
          />
          <label class="form-check-label mt-2 mb-0" for="isSamePart">
            Continue for future shifts until new Production
          </label>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss(); close2()">
      Cancel
    </button>
    <button
      class="btn btn-danger"
      [disabled]="isCurrentShift || !isShiftEditable"
      (click)="deletePlanning()"
    >
      Delete
    </button>
    <button
      class="btn btn-primary"
      [disabled]="formData.invalid || !isShiftEditable"
      (click)="saveEvent('Edit')"
    >
      Update
    </button>
  </div>
</ng-template>
<ng-template #editcontentadd let-modal>
  <div class="modal-header">
    <h5>Are you sure need to change the production</h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      &times;
    </button>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button class="btn btn-primary" (click)="modal.dismiss(); confirm()">
      Edit
    </button>
  </div>
</ng-template>

<ng-template #changeContent let-modal>
  <div class="modal-header">
    <h5>Edit production</h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      &times;
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="step === 1">
      <p>Do you need to change only the operator?</p>

      <button
        class="btn btn-primary me-2"
        (click)="onOperatorChoice(true, modal)"
      >
        Yes
      </button>
      &nbsp;
      <button
        class="btn btn-outline-secondary"
        (click)="onOperatorChoice(false, modal)"
      >
        No
      </button>
    </div>

    <div *ngIf="step === 2">
      <p>Do you need to configure production?</p>

      <button
        class="btn btn-primary me-2"
        (click)="onProductionChoice(true, modal, null)"
      >
        Yes
      </button>
      &nbsp;
      <button
        class="btn btn-outline-secondary"
        (click)="onProductionChoice(false, modal, null)"
      >
        No
      </button>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
  </div>
</ng-template>
